<template>

<div class="title">
	
	<span><slot></slot></span>
	
</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.title {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #698c9e;
	padding: 10px;
    background-color: #19455c;
    border-radius: 10px 10px 0px 0px;
    border-bottom: 1px solid #2b5870;
    text-transform: uppercase;
}

</style>
